import { defineStore } from 'pinia'
import { api } from '@/plugins/axios'
import router from '@/router'
import { useCartStore } from './cart'

let bearer = (localStorage.getItem('bearer')) ? JSON.parse(localStorage.getItem('bearer')) : null
let user = (localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')) : null

// let access_token;
// if(bearer){
//   access_token = bearer.access_token;
// }

export const useAuthStore = defineStore('auth-store', {
  // State (if you need to store any date-related state)
  state: () => ({
    loading: false,
    user: user,
    bearer: bearer,
    loginData: {
      email: '',
      password: '',
    },
    initialLoginData: {
      email: '',
      password: '',
    },
    forgotPasswordData: {
      email: '',
    },
    initialForgotPasswordData: {
      email: '',
    },
    resetPasswordData: {
      token: '',
      email: '',
      password: '',
      password_confirmation: '',
    },
    initialResetPasswordData: {
      token: '',
      email: '',
      password: '',
      password_confirmation: '',
    },
    registerData:{
      first_name: '',
      last_name: '',
      username: '',
      mobile_no: '',
      email: '',
      password: '',
      password_confirmation: '',
      // terms: false,
    },
    initialRegisterData:{
      first_name: '',
      last_name: '',
      username: '',
      mobile_no: '',
      email: '',
      password: '',
      password_confirmation: '',
      // terms: false,
    },
    successMessage: '',
    errorMessage: '',
    isSubmitting: false,
    serverError: [],
  }),

  // Getters (computed properties)
  getters: {
    isServeError: (state) => {
      return state.serverError ? true : false;
    },
  },

  // Actions (methods)
  actions: {    
    async register() {
      try {
        this.isSubmitting = true
        this.errorMessage = ''
        this.successMessage = ''
        this.resetServerError();

        const response = await api.post('register', this.registerData)
        const data = response.data

        if (data.error === false && data.code === 200) {
          // ✅ Save token & user info (you can use Pinia or localStorage)
          localStorage.setItem('access_token', data.results.access_token)
          localStorage.setItem('token_type', data.results.token_type)
          localStorage.setItem('user', JSON.stringify(data.results.user))

          this.user = { ...data.results.user }
          this.bearer = {
            access_token: response.data.results.access_token,
            expires_at: response.data.results.expires_at
          }
          localStorage.setItem('bearer', JSON.stringify(this.bearer));
          this.setTokenInApi(response.data.results.access_token)

          const cartStore = useCartStore()
          await cartStore.syncCart()

          this.successMessage = data.message || 'Signup successful! 🎉'

          window.location.href = '/home'
          
        } else {
          throw new Error(data.message || 'Signup failed.')
        }
      } catch (e) {
        console.log(e)
        this.errorMessage = e.response.data.message
        this.serverError = e.response.data.results;
      } finally {
        this.isSubmitting = false
      }
    },
    async login() {
      try {
        this.isSubmitting = true
        this.errorMessage = ''
        this.successMessage = ''
        this.resetServerError();

        const response = await api.post('login', this.loginData)
        const data = response.data

        if (data.error === false && data.code === 200) {
          // ✅ Save token & user info (you can use Pinia or localStorage)
          localStorage.setItem('access_token', data.results.access_token)
          localStorage.setItem('token_type', data.results.token_type)
          localStorage.setItem('user', JSON.stringify(data.results.user))
          this.user = { ...data.results.user }
          this.bearer = {
            access_token: response.data.results.access_token,
            expires_at: response.data.results.expires_at
          }
          localStorage.setItem('bearer', JSON.stringify(this.bearer));
          this.setTokenInApi(response.data.results.access_token)

          const cartStore = useCartStore()
          await cartStore.syncCart()

          this.successMessage = data.message || 'Login successful! 🎉'
          
          this.resetAction()

          window.location.href = '/home'
          
        } else {
          throw new Error(data.message || 'Login failed.')
        }
      } catch (e) {
        console.log(e)
        this.errorMessage = e.response.data.message
        this.serverError = e.response.data.results;
      } finally {
        this.isSubmitting = false
      }
    },
    setTokenInApi (token) {
      if (!token) {
        delete api.defaults.headers.common.Authorization
        return
      }
      api.defaults.headers.common.Authorization = `Bearer ${token}`
    },
    async forgotPassword() {
      try {
        this.isSubmitting = true
        this.errorMessage = ''
        this.successMessage = ''
        this.resetServerError()

        const response = await api.post('forgot-password', this.forgotPasswordData)
        const data = response.data

        if (data.error === false && (data.code === 200 || response.status === 200)) {
          this.successMessage = data.message || 'Password reset link sent to your email.'
          this.resetForgotPasswordData()
        } else {
          throw new Error(data.message || 'Failed to send password reset link.')
        }
      } catch (e) {
        console.log(e)
        this.errorMessage = e.response?.data?.message || 'An error occurred.'
        if (e.response?.data?.results) {
          this.serverError = e.response.data.results
        }
      } finally {
        this.isSubmitting = false
      }
    },
    async resetPassword() {
      try {
        this.isSubmitting = true
        this.errorMessage = ''
        this.successMessage = ''
        this.resetServerError()

        const response = await api.post('reset-password', this.resetPasswordData)
        const data = response.data

        if (data.error === false && (data.code === 200 || response.status === 200)) {
          this.successMessage = data.message || 'Password has been reset successfully.'
          this.resetResetPasswordData()
          setTimeout(() => {
            window.location.href = '/login'
          }, 2000)
        } else {
          throw new Error(data.message || 'Failed to reset password.')
        }
      } catch (e) {
        console.log(e)
        this.errorMessage = e.response?.data?.message || 'An error occurred.'
        if (e.response?.data?.results) {
          this.serverError = e.response.data.results
        }
      } finally {
        this.isSubmitting = false
      }
    },
    resetServerError () {
      this.serverError = [];
    },
    resetRegisterData () {
      Object.assign(this.registerData, {...this.initialRegisterData});      
    },
    resetAction(){
      this.resetServerError();
      this.resetRegisterData();
    },
    resetLoginData () {
      Object.assign(this.loginData, {...this.initialLoginData});      
    },
    resetForgotPasswordData () {
      Object.assign(this.forgotPasswordData, {...this.initialForgotPasswordData});
    },
    resetResetPasswordData () {
      Object.assign(this.resetPasswordData, {...this.initialResetPasswordData});
    },
  }
});
